var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home text-center"},[_vm._m(0),_c('md-icon',[_vm._v("thumb_up")]),_c('p',[_vm._v("This exam isn't available anymore!")])],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h2',[_vm._v("Exam "),_c('b',[_vm._v("Unavailable!")])])
}]

export { render, staticRenderFns }